import { DidDismissOnHoldPassesAlert } from '@/types';

import { StorageService } from './storage';

enum TransientKeys {
  DidDismissOnHoldPassesAlert = 'didDismissOnHoldPassesAlert',
}

class TransientStorage {
  private readonly backingStore: StorageService<TransientKeys>;

  constructor() {
    this.backingStore = new StorageService(window.sessionStorage);
  }

  public getDidDismissOnHoldPassesAlert(): DidDismissOnHoldPassesAlert {
    return this.backingStore.getItem(TransientKeys.DidDismissOnHoldPassesAlert, false);
  }

  public setDidDismissOnHoldPassesAlert(didDismiss: DidDismissOnHoldPassesAlert): void {
    this.backingStore.setItem(TransientKeys.DidDismissOnHoldPassesAlert, didDismiss);
  }
}

export const TransientStorageService = new TransientStorage();
